/**
 * @generated SignedSource<<d455888d7527288e17c0233fed1992ef>>
 * @relayHash 0f51e83f0ae891e8de0f91a79b06a759
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0f51e83f0ae891e8de0f91a79b06a759

import { ConcreteRequest } from 'relay-runtime';
export type VerifyMedicationStatus = "NONE" | "NOT_ENQUIRED" | "SOME";
export type chVerifyMedicationQuery$variables = {
  appointmentId: string;
  patientId: string;
  skip: boolean;
};
export type chVerifyMedicationQuery$data = {
  readonly medicationVerification?: {
    readonly result?: {
      readonly currentAppointmentId: string;
      readonly isVerified: boolean;
      readonly lastVerifiedAt: string | null;
      readonly lastVerifiedBy: string | null;
      readonly lastVerifyMedicationStatus: VerifyMedicationStatus | null;
      readonly patientId: string;
    };
  };
};
export type chVerifyMedicationQuery = {
  response: chVerifyMedicationQuery$data;
  variables: chVerifyMedicationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appointmentId",
    "variableName": "appointmentId"
  },
  {
    "kind": "Variable",
    "name": "patientId",
    "variableName": "patientId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MedicationVerificationOutput",
      "kind": "LinkedField",
      "name": "result",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVerified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "patientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentAppointmentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastVerifiedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastVerifiedBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastVerifyMedicationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ch_SuccessMedicationVerificationResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chVerifyMedicationQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "medicationVerification",
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ch_medicationVerification",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chVerifyMedicationQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "medicationVerification",
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ch_medicationVerification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0f51e83f0ae891e8de0f91a79b06a759",
    "metadata": {},
    "name": "chVerifyMedicationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "18973b581e1cfdcfe591ccb08328d243";

export default node;
